<style lang="scss">
  @use "../../../../../assets/css/design-system/mixins";
  @use "../../../../../assets/css/design-system/colors";
  @use "../../../../../assets/css/design-system/utils";

  .month-container {
    display: inline-flex;
    flex-direction: column;
    padding: 0 utils.in_rem(20px);
    width: utils.in_rem(302px);
  }
</style>

<script>
  import DayLabels from "../../DayLabels.svelte";
  import MonthGrid from "../../MonthGrid.svelte";
  import MonthHeader from "../../MonthHeader.svelte";
  import { getDatePickerContext } from "../context.svelte.js";
  import { constructCalendar } from "../../utils";

  let { handleDayClick = () => {} } = $props();

  const datePickerContext = getDatePickerContext();

  let referenceDate = $derived(
    datePickerContext.pendingDate ||
      datePickerContext.selectedDate ||
      new Date()
  );

  let manualYear = $state(null);
  let manualMonth = $state(null);

  let year = $derived(
    manualYear === null ? referenceDate.getFullYear() : manualYear
  );
  let month = $derived(
    manualMonth === null ? referenceDate.getMonth() : manualMonth
  );

  let highlightedDate = $derived(
    datePickerContext.pendingDate || datePickerContext.selectedDate
  );

  let weeks = $derived(
    constructCalendar(
      year,
      month,
      highlightedDate,
      highlightedDate,
      datePickerContext.allowFuture,
      datePickerContext.allowPast,
      false
    )
  );

  const previousMonth = () => {
    let newMonth = month - 1;
    let newYear = year;
    if (newMonth < 0) {
      newMonth = 11;
      newYear -= 1;
    }
    manualMonth = newMonth;
    manualYear = newYear;
  };

  const nextMonth = () => {
    let newMonth = month + 1;
    let newYear = year;
    if (newMonth > 11) {
      newMonth = 0;
      newYear += 1;
    }
    manualMonth = newMonth;
    manualYear = newYear;
  };
</script>

<div class="month-container">
  <MonthHeader {month} {year} onPrevious={previousMonth} onNext={nextMonth} />
  <DayLabels />
  <MonthGrid {weeks} onDayClick={handleDayClick} isRange={false} />
</div>
